import { render, staticRenderFns } from "./unpaid-detail.vue?vue&type=template&id=605d9ed8&"
import script from "./unpaid-detail.vue?vue&type=script&lang=ts&"
export * from "./unpaid-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports